export const lostItem = {
  title: 'Inventory(Lost Items)',
}
